import {
    getCoprincipalAccountMailboxInfos,
    StartupFilter,
    ContractsSupportedFilter,
} from 'owa-account-source-list-store';
import type { MailboxInfo } from 'owa-client-types';
import { isConsumer, isPremiumConsumer } from 'owa-session-store';

export function areAnyAccountsEnterpriseOrPremiumConsumer(): boolean {
    const accountMailboxes = getCoprincipalAccountMailboxInfos(
        StartupFilter.StartingOrCompleteOrError,
        ContractsSupportedFilter.Any
    );
    return accountMailboxes.some(
        (mailboxInfo: MailboxInfo) =>
            !isConsumer(undefined, mailboxInfo) || isPremiumConsumer(mailboxInfo)
    );
}
